import { jsx } from "react/jsx-runtime";
const PlusIcon = (props) => /* @__PURE__ */ jsx("svg", { ...props, viewBox: "0 0 1024 1024", children: /* @__PURE__ */ jsx("path", { d: "M480 168C476.686 168 474 170.686 474 174V474H174C170.686 474 168 476.686 168 480V544C168 547.314 170.686 550 174 550H474V850C474 853.314 476.686 856 480 856H544C547.314 856 550 853.314 550 850V550H850C853.314 550 856 547.314 856 544V480C856 476.686 853.314 474 850 474H550V174C550 170.686 547.314 168 544 168H480Z" }) });
export {
  PlusIcon
};
